<template>
    <div style="width:100%;float:left;">
      <CCard>
        <CCardHeader>Customer Scorecard</CCardHeader>
        <CCardBody>
          <div class="all" v-if="data && fields">
            <CDataTable
            v-if="data && fields"
            :items="data"
            :fields="fields"
            >
                <template #total_quantity="{item}">
                    <td>
                    {{Math.abs(item.total_quantity)}}
                    </td>
                </template>
                <template #total_amount="{item}">
                    <td>
                    ${{Math.abs(item.total_amount)}}
                    </td>
                </template>
            </CDataTable>
          </div>
          <small-loader v-else></small-loader>
        </CCardBody>
      </CCard>
    </div>
  </template>
  <script>
  var methods = {}

  methods.getCustomerScorecard = function () {
    this.loading = true
    const postData = {
        customer: this.customer_selected
    }
    axios.post(this.$apiAdress + '/api/reports/getCustomerScorecard?token=' + localStorage.getItem('api_token'), postData).then(response => {
        console.log(response)
        this.data = [response.data]
        this.fields = Object.keys(response.data);
        this.loading = false
    })
  }
  
  export default {
    // ===Component name
    name: "CustomerScorecard",
    // ===Props passed to component
    props: ['customer_selected'],
    // ===Components used by this component
    components: {
  
    },
    // ====component Data properties
    data(){
        return{
            loading: true,
            data: null,
            fields: null
        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
        this.getCustomerScorecard()
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
  }
  </script>
  <!-- styles -->
  <!-- adding scoped attribute will apply the css to this component only -->
  <style scoped></style>
  